import React from "react";
import {Card, CardContent, Typography, useMediaQuery} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import {Constants} from "../constants/Constants";
import {grey} from "@material-ui/core/colors";
import Games from "../constants/Games";
import {useTheme} from "@material-ui/core/styles";

export default function HowToPlay(props: any) {
    const theme = useTheme();
    const belowThreshold = useMediaQuery(theme.breakpoints.down(1034));
    return <Card
        style={{
            background: AppColors.CARD_BACKGROUND_COLOR,
            marginRight: 10,
            width: belowThreshold ? '80%' : '40%',
            marginBottom: 10,
        }}>
        <CardContent>
            <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Typography align={"center"} style={{
                    color: 'white',
                    fontWeight: 600
                }}>How To Play</Typography>
                <Typography
                    align={"center"}
                    dangerouslySetInnerHTML={{
                        __html: `<br/>There are <b>5 Games </b>available for you to play.<br/><br/>When you hit the <b style="color: mediumseagreen">PLAY</b> Button, <b style="color: coral">6 numbers</b> would be drawn from <b style="color: indianred">1 to ${Constants.BASE_NUMBER - 1}</b>. These <b style="color: coral">6 numbers</b> are <b>NOT RANDOMLY</b> Selected, but  are rather selected using your <b>Unique Server Seed</b>. Click on the Provably Fair Link above to see how this works`
                    }} style={{
                    paddingTop: 20,
                    padding: 5,
                    color: grey[400]
                }}/>
                <Typography align={"center"} style={{
                    color: 'white',
                    paddingTop: 20,
                    fontWeight: 600
                }}>To Play:</Typography>
                <ul style={{color: 'white'}}>
                    <li>Select a Game from one of <b>{Games.toString()}</b></li>
                    <br/>
                    <li>When You Select for example <b>{Games.TWO_HITS}</b>, You would be required to pick <b>2
                        Lucky Numbers Per ticket</b>. <br/><br/>If these <b>2 Lucky Numbers Per Ticket</b> are among
                        the <b
                            style={{color: 'coral'}}>6 drawn numbers</b> then
                        you'll win some bitcoins multiplied by a factor for that Ticket. In the case of
                        the <b>{Games.TWO_HITS}</b> game, that would be <b>240 * Your Stake Per Ticket</b>
                        <br/><br/><b>NOTE:</b> All <b>2
                            Lucky Numbers</b> in
                        a <b>Ticket</b> <b>MUST</b> be among the <b
                            style={{color: 'coral'}}>6 drawn numbers</b> before you can win bitcoins for that Ticket.
                    </li>
                    <br/>
                    <li>The above applies to all other games respectively,<br/> <b>{Games.THREE_HITS}</b>=3 Lucky
                        Numbers Per
                        Ticket, <b>{Games.FOUR_HITS}</b>=4 Lucky Numbers Per Ticket. Etc..
                    </li>
                    <br/>
                    <li>You can buy as many Tickets as you can afford before hitting the <b style={{
                        color: 'mediumseagreen'
                    }}>PLAY</b> Button
                    </li>
                    <br/>
                    <li>When you buy more than <b>1 Ticket</b>, your stake would be automatically multiplied by the
                        number of
                        tickets bought.<br/>So, imagine you are staking <b>0.00001BTC</b> and you added 2 tickets, you
                        would be
                        spending <b>0.00001BTC * 2 = 0.00002BTC</b> in total.
                    </li>
                    <br/>
                    <li>This Game is not for Persons Under the Age of <b>18</b>
                    </li>
                    <br/>
                    <li><b>Game Responsibly!</b></li>
                </ul>
            </div>
        </CardContent>
    </Card>
}